import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import "swiper/swiper-bundle.css";
import "video-react/dist/video-react.css";
import "../css/css.css";
import { navigationRouter, screenRouter } from "../router";
import URI from "urijs";
import general, { redux } from "./../general";
import { NavLink, NavView } from "../lib/Navigation";
import {
  useEventListener,
  useLocalStorageState,
  useMount,
  useTimeout,
} from "ahooks";
import ActiveContext from "../lib/ActiveContext";
import useActiveState from "../lib/useActiveState";
import $ from "jquery";
import { state } from "../lib/reducer";
import { useSelector } from "react-redux";
import Dialog from "../lib/Dialog";
import Image from "../lib/Image";
import { Link, useHistory, useLocation } from "react-router-dom";
import useUrlState from "@ahooksjs/use-url-state";
import dayjs from "dayjs";
import MobileDetect from "mobile-detect";
import { prod } from "../config";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import CryptoJS from "crypto-js";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { CSSTransition } from "react-transition-group";
import { useLogin } from "../lib/LoginContext";
import { getUuidCallback, behaviorTrigger } from "../utils/trigger";
import PhoneLogin from "./account/PhoneLogin";
import PasswordLogin from "./account/Login";
import Register from "./account/Register";
import PswEdit from "./account/Forget";
import { sortEncodeAndHash } from "../utils/signFunc";
import { getKidCallback } from "../utils/kidCallback";
import { storageLocal, sessionLocal } from "../view/util/storage";

const mobileDetect = new MobileDetect(navigator.userAgent);

let prev = null;

function isQueryFlagTruthy(value) {
  if (value == null || value === "") return false;
  if (value === false || value === "false" || value === "0") return false;
  return true;
}

/** Hash 路由：合并 # 前 search、hash 内 query、react-router location */
function getMergedRouteQuery(location) {
  const queries = [];
  if (window.location.search) {
    queries.push(URI(window.location.search).query(true));
  }
  const hash = (location.hash || window.location.hash || "").replace(/^#/, "");
  if (hash) {
    const hashPath = hash.startsWith("/") ? hash : `/${hash}`;
    queries.push(URI(hashPath).query(true));
  }
  queries.push(URI(location.pathname + location.search).query(true));
  return Object.assign({}, ...queries);
}

/** 长期绕过加书签教程（仅 URL 单独带 standalone、无 auto 时写入，避免描述文件回流误写入） */
const BOOKMARK_GUIDE_BYPASS_KEY = "bookmarkGuideBypass";

// 入口文件
export default () => {
  let history = useHistory();
  let location = useLocation();

  useEffect(() => (general.history = history), [history]);
  useEffect(() => (general.location = location), [location]);

  let [params, setParams] = useUrlState({}, { navigateMode: "replace" });

  const [standalone, setStandalone] = useLocalStorageState("standalone");
  const mergedRouteQuery = getMergedRouteQuery(location);
  const autoInUrl =
    isQueryFlagTruthy(mergedRouteQuery.auto) || isQueryFlagTruthy(params.auto);
  const standaloneInUrl =
    isQueryFlagTruthy(mergedRouteQuery.standalone) ||
    isQueryFlagTruthy(params.standalone);
  // auto：仅当前 URL 有效；standalone：URL 或 localStorage 长期记住（勿读 standalone 键，回流后仍要展示教程）
  if (standaloneInUrl && !autoInUrl) {
    sessionLocal.set(BOOKMARK_GUIDE_BYPASS_KEY, 1);
  }
  const hideBookmarkGuide =
    autoInUrl || standaloneInUrl || sessionLocal.has(BOOKMARK_GUIDE_BYPASS_KEY);

  useEffect(() => {
    const q = getMergedRouteQuery(location);
    const standaloneVal = params.standalone ?? q.standalone;
    if (isQueryFlagTruthy(standaloneVal)) {
      setStandalone(standaloneVal);
    }
  }, [
    location.pathname,
    location.search,
    location.hash,
    params.standalone,
    setStandalone,
  ]);

  useMount(() => {
    if (params.bd_vid && params.agent != "6pk1") {
      storageLocal.set("bd_vid", params.bd_vid);
      storageLocal.set("boxFirstKid", params.bd_vid);
    }
  });

  const [active, setActive] = useLocalStorageState("active", {
    defaultValue: {},
  });
  const { aplus_queue } = window;

  const { theme } = useSelector(state);
  let [agent, setAgent] = useActiveState("agent");
  let [udid, setUdid] = useActiveState("udid");
  let [key, setKey] = useActiveState("key");
  let [invalidKeys, setInvalidKeys] = useLocalStorageState("invalid-keys", {
    defaultValue: [],
  });
  let [app, setApp] = useActiveState("app");
  useMount(async () => {
    if (params.agent) {
      setAgent((agent = params.agent));
      localStorage.setItem("agent", params.agent);
    }

    if (params.udid) {
      setUdid(params.udid);
    }

    if (params.key) {
      if (!invalidKeys.includes(params.key)) {
        setKey((key = params.key));
      }
    } else {
      setKey((key = ""));
    }

    if (!app.brand) {
      if (params.brand) {
        app.brand = params.brand;
      }
      let tmp = {
        "9917游戏": "9917",
        BT玩: "btwan",
        嗨玩游戏: "hiwan",
        "97游戏盒": "97",
        泡泡熊: "zc",
        大碗游戏盒: "dawan",
        疯玩游戏: "fw",
      };
      if (app.appname && tmp[app.appname]) {
        app.brand = tmp[app.appname];
      }
    } else {
      if (params.brand) {
        app.brand = params.brand;
      }
    }

    setApp((app = { ...app, ...params }));

    if (!key) {
      await general.axios
        .post("/v3/base/newindex/setKeyUdid", {
          agent,
          brand: params.brand,
          appname: params.appname,
          appicon: params.appicon,
          applogo: params.applogo,
          flash_screen: params.flash_screen,
        })
        .then((res) => {
          let { status, data } = res.data;
          if (!status.succeed) {
            Dialog.error(status.error_desc);
            return;
          }
          setKey((key = data.key));
          setParams((params = { ...params, agent: agent, key: data.key }));
          if (
            params.appname ||
            params.appicon ||
            params.applogo ||
            params.flash_screen
          ) {
            setParams(
              (params = {
                ...params,
                appname: null,
                appicon: null,
                applogo: null,
                flash_screen: null,
              }),
            );
          }
        })
        .catch((error) => Dialog.error("setKeyUdid " + error.message));
    }

    if (key && (app.key !== key || !udid)) {
      general.axios
        .post("/v3/base/newindex/getKeyUdid", {
          agent,
          key,
          brand: params.brand,
          not_check_ua: true,
        })
        .then((res) => {
          let { status, data } = res.data;
          if (!status.succeed) {
            Dialog.error(status.error_desc);
            return;
          }
          if (data.key && data.key !== key) {
            if (!invalidKeys.includes(app.key)) {
              setInvalidKeys([...invalidKeys, key]);
            }
            setKey((key = data.key));
            setParams({ key });
          }
          for (const key of ["appname", "appicon", "applogo", "flash_screen"]) {
            if (app[key + "_lock"]) {
              delete data[key];
            }
          }
          setApp((app = { ...app, ...data }));

          if (data.brand) {
            setParams((params = { ...params, brand: data.brand }));
          }
          if (
            params.appname ||
            params.appicon ||
            params.applogo ||
            params.flash_screen
          ) {
            const ts = [];
            for (const key of [
              "appname",
              "appicon",
              "applogo",
              "flash_screen",
            ]) {
              if (params[key]) {
                ts[key] = params[key];
                ts[key + "_lock"] = params[key];
              }
            }
            setApp((app = { ...app, ...ts }));
            setParams(
              (params = {
                ...params,
                appname: null,
                appicon: null,
                applogo: null,
                flash_screen: null,
              }),
            );
          }
        })
        .catch((err) => Dialog.error("getKeyUdid " + err.message));
    }

    if (key) {
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["openid", key],
      });
    }
  });

  const urlLogin = () => {
    // SDK等其他地方进入盒子时  实现盒子的自动登录
    if (
      !localStorage.getItem("logout") &&
      params.userid &&
      params.username &&
      params.token
    ) {
      localStorage.setItem("user_id", params.userid);
      localStorage.setItem("username", params.username);
      localStorage.setItem("token", params.token);

      // 若存在url参数 则进行跳转
      if (params.url) {
        let uri = new URI(window.location.hash.substring(1));
        let query = uri.query(true);

        query.userid = undefined;
        query.username = undefined;
        query.token = undefined;

        uri.query(query);
        console.warn(uri.toString());
        history.replace(uri.toString());
      }
    }
  };
  useMount(urlLogin);

  useEffect(() => {
    history.action !== "POP" && urlLogin();
  }, [params, history.action]);

  useEffect(() => {
    params.udid && setUdid(params.udid);
  }, [params.udid]);

  useEffect(() => {
    // iOS加书签时 设置书签标题及icon、启动页等
    if (app.appname) {
      document.title = app.appname;
      $("meta[name=apple-mobile-web-app-title]").attr("content", app.appname);
    }
    if (app.appicon) {
      if (!app.brand || app.brand == "9917") {
        $("link[id=appleTouchIcon]").attr(
          "href",
          "https://filestorage.9917.cn/agent-material/bc8f/icon.png",
        );
      } else {
        $("link[id=appleTouchIcon]").attr("href", app.appicon);
      }
    }
    if (app.flash_screen) {
      [
        { width: 2048, height: 2732 },
        { width: 1668, height: 2388 },
        { width: 1536, height: 2048 },
        { width: 1668, height: 2224 },
        { width: 1620, height: 2160 },
        { width: 1284, height: 2778 },
        { width: 1170, height: 2532 },
        { width: 1125, height: 2436 },
        { width: 1242, height: 2688 },
        { width: 828, height: 1792 },
        { width: 1242, height: 2208 },
        { width: 750, height: 1334 },
        { width: 640, height: 1136 },
      ].forEach(({ width, height }) => {
        $('link[id="' + (width + "-" + height) + '"]').attr(
          "href",
          app.flash_screen +
            (width === 1170 && height === 2532
              ? "!iphone12pro"
              : "!iphone_" + width + "x" + height),
        );
      });
    }
  }, [app]);

  const encodeAndHash = (value) => {
    // Base64 编码
    const base64Encoded = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(value),
    );

    // MD5 加密
    const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);

    return md5Hash;
  };

  useEffect(() => {
    let time = new Date().getTime() + "";
    let sign = `991702{"appid":"991702","name":"1732609027","timestamp":"${time}"}586C3C60E2F21EB62B2EEB5A1E1DF845`;

    general.axios
      .post("/get/sts", {
        appid: "991702",
        timestamp: time,
        sign: encodeAndHash(sign),
        name: "1732609027",
      })
      .then((res) => {
        if (res.data.data.accessKeyId) {
          let umModule;
          let deviceToken;

          // 阿里云设备指纹
          ALIYUN_FP.use("um", (state, um) => {
            if (state === "loaded") {
              umModule = um;
              um.init({
                appKey: res.data.data.accessKeyId,
                appName: "webbox",
                //endpoints : ['https://cloudauth-device.aliyuncs.com']
              });
            }
          });

          setTimeout(() => {
            // 后续 注册 时，要将deviceToken传给后端
            deviceToken = umModule.getToken();
            localStorage.setItem("deviceToken", deviceToken);
          }, 3000);
        }
      })
      .catch((error) => console.log("sts访问失败啦~~~~~~~~~~~~ " + error));
  }, []);

  const [config, setConfig] = useActiveState("config");
  useMount(() => {
    general.axios
      .post("/v3/base/common/getConfig")
      .then((res) => {
        let { status, data } = res.data;
        if (status.succeed) {
          setConfig({ ...config, ...data });
        }
      })
      .catch((error) => Dialog.error("getConfig " + error.message));
  });

  useEffect(() => {
    if (
      config.udid_usable !== undefined &&
      !config.udid_usable &&
      localStorage.getItem("udid_usable")
    ) {
      localStorage.setItem("udid_usable", "");
    }
  }, [config.udid_usable]);

  const [navs, setNavs] = useState([]);
  const [action, setAction] = useState([]);
  const handleNavs = () => {
    if (general.callbacking) {
      return;
    }
    let uri = URI(window.location.hash.substring(1));
    if (uri.pathname() === "/iframe") {
      let query = uri.query(true);
      if (query.url) {
        let iframeUri = URI(query.url);
        let iframeQuery = iframeUri.query(true);
        if (
          iframeQuery.username !== localStorage.getItem("username") ||
          iframeQuery.token !== localStorage.getItem("token")
        ) {
          history.replace(
            uri
              .setQuery(
                "url",
                iframeUri
                  .setQuery("username", localStorage.getItem("username"))
                  .setQuery("token", localStorage.getItem("token"))
                  .toString(),
              )
              .toString(),
          );
          uri = URI(window.location.hash.substring(1));
        }
      }
    }
    setNavs((_navs) => {
      let navs = [..._navs];
      let uri2 = URI(uri.search()).removeQuery("callback");
      if (
        uri.pathname().startsWith("/search") ||
        uri.pathname().startsWith("/gift/search")
      ) {
        uri2.removeQuery("kw");
      }
      let url = uri.pathname() + uri2.toString();
      let pathname = uri.pathname();

      let router = navigationRouter.find((item) => item.path === pathname);
      if (router) {
        navs.reverse();
        let index = navs.findIndex((item) => item.url === url);
        navs.reverse();
        if (index > 0) {
          while (navs[navs.length - 1].url !== url) {
            navs.pop();
          }
        }
        if (index === -1) {
          navs.push({ ...router, query: uri.query(true), url });
        }
      } else {
        navs = [];
      }
      navs = navs.map((item, index, items) => {
        item.index = 700 + index + 1;
        item.active = items.length - 1 === index;
        item.action = items.length - 1 === index ? history.action : null;
        return item;
      });

      return [...navs];
    });
  };
  useEffect(() => handleNavs(), [history, location]);

  // iOS加书签后重新进入时，如果当前路由是底部导航路由但不是首页，则自动重置到首页
  // 问题原因：iOS Safari在standalone模式下会保存并恢复window.location.hash
  // 当用户在底部导航页面（如/screen-trade）退出应用后，Safari会恢复#/screen-trade
  // 解决方案：在应用启动时，如果是直接启动（没有referrer），且当前路由是底部导航路由但不是首页，则重置到首页
  //
  // 游戏详情加书签：首次从书签冷启动仍进详情，并写入标记；第二次起的重定向在 index.js 里于 React 渲染前完成，避免闪一下详情页
  useLayoutEffect(() => {
    if (!(window.navigator.standalone || standalone)) return;
    const uri = URI(window.location.hash.substring(1));
    if (uri.pathname() !== "/game") return;
    const query = uri.query(true);
    if (!query.id && !query.mid) return;
    // iOS 描述文件安装后经 udid 回调带回 auto=1，勿当作书签二次冷启动
    if (query.auto) return;
    const gameBookmarkOnceKey = "standalone_game_bookmark_first_done";
    const isPageReload = () => {
      try {
        const nav = performance.getEntriesByType?.("navigation")?.[0];
        if (nav?.type === "reload") return true;
        if (
          performance.navigation?.type === performance.navigation?.TYPE_RELOAD
        ) {
          return true;
        }
      } catch (e) {}
      return false;
    };
    if (localStorage.getItem(gameBookmarkOnceKey)) {
      // 登录/注册成功后 location.reload() 仍应留在详情页，不算「第二次从书签冷启动」
      if (!isPageReload()) {
        history.replace("/");
      }
      return;
    }
    localStorage.setItem(gameBookmarkOnceKey, "1");
  }, [standalone, history]);

  useMount(() => {
    // 检查是否是iOS standalone模式
    if (window.navigator.standalone || standalone) {
      // 延迟执行，确保路由系统已初始化
      setTimeout(() => {
        const uri = URI(window.location.hash.substring(1));
        const currentPath = uri.pathname();
        const query = uri.query(true);

        // 检查当前路由是否是底部导航路由之一，但不是首页
        const isScreenRoute = screenRouter.some(
          (item) => item.path === currentPath && item.path !== "/",
        );

        // 如果没有referrer或referrer为空，说明是直接启动的（退出后重新进入）
        // 此时如果当前路由是底部导航路由但不是首页，应该重置到首页
        // 检查URL中是否有特殊参数（如mid、url），如果有则可能是通过特定链接进入的，不重置
        const isDirectLaunch = !document.referrer || document.referrer === "";
        const hasSpecialParams = query.mid || query.url;

        if (isScreenRoute && isDirectLaunch && !hasSpecialParams) {
          history.replace("/");
        }
      }, 100);
    }
  });

  useMount(() => {
    redux.subscribe(() => {
      if (redux.getState().url) {
        console.log("location", { ...location }, window.location.href);
        handleNavs();
      }
    });
    redux.subscribe(() => {
      let screen = redux.getState().screenRouter?.screen;
      if (screen) {
        history.replace(screen.replace("/", "/screen-"));
      }
    });
  });

  useTimeout(async () => {
    if (
      !active.time ||
      dayjs(active.time).format("YYYY-MM-DD") !== dayjs().format("YYYY-MM-DD")
    ) {
      setActive((active) => ({ ...active, time: dayjs().valueOf() }));
      aplus_queue.push({
        action: "aplus.sendPV",
        arguments: [
          { is_auto: false },
          {
            page: "index",
            isApp: !!window.navigator.standalone,
            agent,
          },
        ],
      });
      aplus_queue.push({
        action: "aplus.record",
        arguments: [
          "enter",
          "enter",
          {
            isApp: !!window.navigator.standalone,
            agent,
          },
        ],
      });
    }

    if (!storageLocal.has("tgm_uuid")) {
      await getUuidCallback();
    }

    if ((window.navigator.standalone || standalone) && !active.activate) {
      setActive((active) => ({ ...active, activate: dayjs().valueOf() }));

      if (storageLocal.has("tgm_uuid")) {
        behaviorTrigger("activate");
        getDyGameId();
      }

      aplus_queue.push({
        action: "aplus.record",
        arguments: [
          "activate",
          "activate",
          {
            agent,
          },
        ],
      });

      if (params?.mid && !params.is_ldy) {
        history.push("/game?mid=" + params.mid);
      }
    }
  }, 1527);

  const getDyGameId = () => {
    const timeCall = new Date().getTime().toString();

    let objData = {
      vid: storageLocal.get("tgm_uuid"),
    };

    general.axios
      .post("/tgm/open_game_detail", objData, {
        headers: {
          sign: sortEncodeAndHash({
            ...objData,
            timestamp: timeCall,
          }),
          timestamp: timeCall,
          appid: "991701",
        },
      })
      .then((res) => {
        console.log("竞价跳游戏详情吗-----", res);

        if (res?.data?.gameId != 0 && !params.is_ldy) {
          history.push("/game?mid=" + res.data.gameId);
        }
      })
      .catch((error) => console.log("激活行为回传--- " + error));
  };

  const [safeArea, setSafeArea] = useState();
  useEffect(() => {
    setSafeArea(
      parseInt($(".safeareatest").css("padding-top")) > 20 ||
        parseInt($(".safeareatest").css("padding-bottom")) > 20,
    );
  });

  function isJSONString(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (error) {
      return false;
    }
  }

  const {
    showLogin,
    setShowLogin,
    isFromLogin,
    setIsFromLogin,
    pswEditShow,
    setPswEditShow,
    registerShow,
    setRegisterShow,
  } = useLogin();

  const [loginType, setLoginType] = useState("code");

  // 监听路由变化，当用户通过滑动返回时重置 isFromLogin 状态
  /*
  React Router 中的 history.action
  history 对象上有个 action 属性，值可能是以下几种：

  PUSH
  调用 history.push() / <Link to="..."> 跳转时触发。
  表示新压入了一条历史记录。

  REPLACE
  调用 history.replace() 跳转时触发。
  表示替换了当前历史记录。

  POP
  触发 浏览器的前进 / 后退（比如点击浏览器回退按钮）时触发。
  它不会主动产生一条新的记录，而是“弹出”历史栈里的记录。
  */
  useEffect(() => {
    // 当路由发生变化时，检查是否是通过点击返回按钮触发的
    if (history.action === "POP") {
      const isFromBackButton = sessionStorage.getItem("isFromBackButton");
      if (!isFromBackButton) {
        // 如果不是通过点击返回按钮触发的，则重置 isFromLogin
        setIsFromLogin(false);
      } else {
        // 清除标记
        sessionStorage.removeItem("isFromBackButton");
      }
    }
  }, [location, history.action, setIsFromLogin]);

  // 监听H5页面行为回传
  useEventListener("message", (e) => {
    if (e.data === "undefined" || !isJSONString(e.data)) {
      return;
    }

    const message = JSON.parse(e.data);
    if (message.type === "history") {
      let url = message.url;

      if (url === "back") {
        history.goBack();
        return;
      }
      if (url.startsWith("box9917://")) {
        url = url.replace("box9917://", "");
      }
      let uri = URI(url);

      if (!uri.scheme()) {
        if (url.startsWith("/login")) {
          localStorage.removeItem("user_id");
          localStorage.removeItem("username");
          localStorage.removeItem("password");
          localStorage.removeItem("token");
          localStorage.setItem("logout", true);
          sessionLocal.remove("popupData");

          if (uri?._parts?.query) {
            sessionStorage.setItem("isHaveBack", "yes");
          } else {
            sessionStorage.setItem("isHaveBack", "");
          }

          setShowLogin(true);
          document.body.style.overflow = "hidden";
          return;
        } else {
          history.push(url);
        }
      } else {
        window.location.href = url;
      }
    } else if (message.type === "passBack") {
      console.log("H5页面行为回传---------------", message);
    } else if (message.type === "payUrl") {
      console.log("云挂机H5回传---------------", message);

      window.location.href = message.url;
    } else if (
      message.type == "exitCloudApp" ||
      message.type == "leaveHanging"
    ) {
      console.log(message);
    } else if (message.type == "changePage") {
      history.push(message.url);
    }
  });

  useEffect(
    function () {
      let url = window.location.hash.substring(1);
      let uri = URI(url);
      if (
        localStorage.getItem(`browse_${url}`) !==
        dayjs(active.time).format("YYYY-MM-DD")
      ) {
        localStorage.setItem(
          `browse_${url}`,
          dayjs(active.time).format("YYYY-MM-DD"),
        );
        let data = {
          isApp: !!window.navigator.standalone,
          agent,
          prevPath: prev?.path,
          prevUrl: prev?.url,
          currPath: uri.pathname(),
          currUrl: url,
        };

        aplus_queue.push({
          action: "aplus.record",
          arguments: ["browse", "browse", data],
        });
      }
      prev = {
        path: uri.pathname(),
        url: url,
      };
    },
    [location],
  );

  // 监听safe-area-inset-top参数 设置安全区域顶部内边距
  let [safeAreaInsetTop, setSafeAreaInsetTop] = useState();
  useMount(() => {
    if (params["safe-area-inset-top"]) {
      setSafeAreaInsetTop(
        (safeAreaInsetTop = params["safe-area-inset-top"] * 1),
      );
      if (safeAreaInsetTop) {
        $("head").append(
          "<style>:root { --safe-area-inset-top: " +
            safeAreaInsetTop +
            "px; }</style>",
        );
      }
    }
  });

  const [tikShow, setTikShow] = useActiveState("tikShow");

  // 监听自定义登录事件
  useMount(() => {
    const handleShowLogin = (event) => {
      setShowLogin(event.detail);
    };

    window.addEventListener("showLogin", handleShowLogin);

    return () => {
      window.removeEventListener("showLogin", handleShowLogin);
    };
  });

  // 处理登录弹窗显示时的高 z-index iframe 遮挡问题
  useEffect(() => {
    if (showLogin) {
      const hiddenIframes = [];

      // 处理 iframe 的函数
      const handleIframe = (iframe) => {
        const style = window.getComputedStyle(iframe);
        const zIndex = parseInt(style.zIndex) || 0;

        // 如果 iframe 的 z-index 大于登录弹窗的 z-index (9999998)，或者符合特征描述，则隐藏它
        if (
          zIndex === 2147483647 &&
          style.position === "fixed" &&
          style.top === "0px" &&
          style.left === "0px" &&
          style.width === "100%" &&
          style.height === "100%"
        ) {
          // 保存原始样式
          const originalDisplay = iframe.style.display;
          iframe.style.display = "none";
          hiddenIframes.push({ iframe, originalDisplay });
        }
      };

      // 查找所有现有的 iframe
      const iframes = document.querySelectorAll("iframe");
      iframes.forEach(handleIframe);

      // 使用 MutationObserver 监控新添加的 iframe
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeName === "IFRAME") {
              handleIframe(node);
            }
            // 也检查子节点中的 iframe
            if (node.querySelectorAll) {
              node.querySelectorAll("iframe").forEach(handleIframe);
            }
          });
        });
      });

      // 开始观察 DOM 变化
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // 清理函数：恢复 iframe 的原始样式并停止观察
      return () => {
        observer.disconnect();
        hiddenIframes.forEach(({ iframe, originalDisplay }) => {
          if (iframe && iframe.parentNode) {
            iframe.style.display = originalDisplay || "";
          }
        });
      };
    }
  }, [showLogin]);

  useMount(() => {
    if (navigator.userAgent == "uniapp") {
      let x;
      document.addEventListener("touchstart", (e) => {
        x = e.changedTouches[0].pageX;
      });
      document.addEventListener("touchend", (e) => {
        if (x !== undefined && x < 23 && e.changedTouches[0].pageX - x > 23) {
          history.goBack();
        }
        x = undefined;
      });
    }

    // // 抖音审核
    // general.axios
    //   .post("/v3/base/apphome/agentDisplay")
    //   .then((res) => {
    //     let { status, data } = res.data;
    //     if (status.succeed) {
    //       console.log("抖音审核是否显示----", data);

    //       setTikShow(data);
    //     }
    //   })
    //   .catch((error) => Dialog.error("getConfig " + error.message));
  });

  SwiperCore.use([Pagination]);

  const swiperRef = useRef(null);
  const swiperLinkRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(1);
  useEffect(() => {
    // 延迟初始化Swiper，确保容器尺寸完全加载
    setTimeout(() => {
      if (swiperLinkRef.current && swiperLinkRef.current.swiper) {
        swiperLinkRef.current.swiper.update();
      }

      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.update();
      }
    }, 300); // 延迟300ms进行更新，确保容器已加载完毕
  }, []); // 仅在组件首次加载时执行

  let userAgent = navigator.userAgent;
  let isIos = userAgent.match(/iphone os|ipad|mac os/i);

  const [isSafari, setIsSafari] = useState(isIos);
  useEffect(() => {
    if (isIos) {
      // 检测是否是特定浏览器，排除 Safari
      if (
        userAgent.match(
          /baidu|mqqbrowser|crios|fxios|edgios|ucbrowser|micromessenger/i,
        ) ||
        userAgent.match(/mobile\/[^\s]+ version\/[^\s]+ safari\/[^\s]+/i)
      ) {
        setIsSafari(false);
      }
    }
  }, []);

  const copyLink = window.location.href;

  const douSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (params?.isDou && !douSafari) {
    document.body.style.overflow = "hidden";
  }

  const getIsjjAgent = async () => {
    const timeCall = new Date().getTime().toString();

    let objData = {
      agent: localStorage.getItem("agent"),
    };

    await general.axios
      .post("/ocpc/NoticeDepart", objData, {
        headers: {
          sign: sortEncodeAndHash({
            ...objData,
            timestamp: timeCall,
          }),
          timestamp: timeCall,
          appid: "991701",
        },
      })
      .then((res) => {
        console.log(res);

        if (res?.data?.data?.isCallback) {
          storageLocal.set("jjAgentShow", "open");
        } else {
          storageLocal.remove("jjAgentShow");

          storageLocal.remove("tgm_uuid");
          storageLocal.remove("bd_vid");
        }
      })
      .catch((error) => console.log("media-point " + error));
  };

  // 活跃上报
  const boxActiveCallback = () => {
    const time = new Date().getTime().toString();

    let objData = {
      kid: CryptoJS.MD5(app.key).toString(CryptoJS.enc.Hex),
      username: app.username,
      code: "index_active",
      description: "盒子活跃",
      agent: app.agent,
    };

    general.axios
      .post("/v4/ReportRecords", objData, {
        headers: {
          sign: sortEncodeAndHash({
            ...objData,
            timestamp: time,
          }),
          timestamp: time,
        },
      })
      .then(async (res) => {
        console.log("活跃上报---", res);
      })
      .catch((error) => console.log("media-point " + error));
  };

  useEffect(async () => {
    getIsjjAgent();
    boxActiveCallback();

    if (!storageLocal.has("boxFirstKid")) {
      await getUuidCallback();
      if (!storageLocal.has("boxFirstKid")) {
        let kid = await getKidCallback();
        storageLocal.set("boxFirstKid", kid);
      }
    }
  }, []);

  const [isWeixin, setIsWeixin] = useState(false);
  useEffect(() => {
    let userAgent = navigator.userAgent;
    if (userAgent.match(/MicroMessenger/i)) {
      setIsWeixin(true);
    }
  }, []);

  // 若为iOS26 则走单独的加书签1、2教程
  const [ios26, setIos26] = useState(false);

  function isIOS26OrLater() {
    const match = navigator.userAgent.match(/Version\/([\d.]+)/);
    const ver = match ? match[1] : null;
    if (!ver) return false;

    const major = parseInt(ver.split(".")[0], 10);
    return major >= 26;
  }
  useEffect(() => {
    const major = isIOS26OrLater();
    setIos26(major);
  }, []);

  const seiviceShowCallback = () => {
    const time = new Date().getTime().toString();

    let objData = {
      applyType: 1,
      code: "xfq",
    };

    general.axios
      .post("/v4/channel_rule", objData, {
        headers: {
          sign: sortEncodeAndHash({
            ...objData,
            timestamp: time,
          }),
          timestamp: time,
        },
      })
      .then((res) => {
        console.log("客服展示回调--------", res);

        if (res.data.code !== 200) {
          Dialog.error(res.data.msg);
          return;
        }

        if (res?.data?.data?.kfUrl) {
          storageLocal.set("kfUrl", res?.data?.data?.kfUrl);
        } else {
          storageLocal.remove("kfUrl");
        }
      })
      .catch((err) => {
        console.log("客服展示回调--------", err);
      });
  };

  const popupShowCallback = () => {
    general.axios
      .get("/v3/base/common/getBoxPopupLimit")
      .then((res) => {
        console.log("获取盒子弹窗限制次数-=--", res);
        sessionLocal.set("boxPopupLimitCount", res?.data?.data?.daily_limit);
      })
      .catch((err) => {
        console.log("获取盒子弹窗限制次数-=--", err);
      });
  };

  useEffect(() => {
    seiviceShowCallback();
    popupShowCallback();
  }, []);

  const [entranceDataList, setEntranceDataList] = useState(true);
  const signShowCallback = () => {
    const time = new Date().getTime().toString();
    const objData = {
      applyType: 1,
      codes: ["xh_trade"],
    };

    general.axios
      .post("/v4/channel_rule_batch", objData, {
        headers: {
          sign: sortEncodeAndHash({
            ...objData,
            timestamp: time,
          }),
          timestamp: time,
        },
      })
      .then((res) => {
        console.log("交易模块是否展示----", res.data);

        if (res.data.code !== 200) {
          Dialog.error(res.data.msg);
          return;
        }

        const showList = res.data.data.filter((item) => item.status == 1);
        setEntranceDataList(showList.length > 0);
      })
      .catch((err) => {
        console.log("签到展示回调--------", err);
      });
  };
  useEffect(() => {
    signShowCallback();
  }, []);

  return (
    <>
      <div
        className={
          "root" +
          (safeArea ? " root-hassafearea" : " root-nosafearea") +
          " theme-" +
          theme +
          (safeAreaInsetTop ? " var-safe-area" : "")
        }
      >
        <div className="safeareatest" />

        {/* 
        window.navigator.standalone 可以确定用户目前访问是否为 书签版访问
        iOS上的Safari浏览器可以让Web应用程序全屏显示，以取得类似本地应用的显示效果。但是这需要用户把Web应用程序的图标添加到主屏幕才可以。
        作为开发者，为了更好的显示效果，我们可能希望自己开发的Web应用程序在非全屏状态下运行时提示用户把Web应用程序的图标添加到主屏幕。

        要检测Web应用程序当前是否运行在全屏状态，只要检测window.navigator.standalone是否为true就可以了，如果这个属性为true则表示Web应用程序
        当前运行在全屏状态，否则运行在非全屏状态。检测到Web应用程序运行在非全屏状态时就可以提示用户把Web应用程序的图标添加到主屏幕 */}
        {/* 
        未加书签  生产环境  手机或者ipad  域名不为本地 
        有活动展示活动  
        没活动  若不是Safari浏览器---展示复制打开Safari弹窗  若是Safari---展示加书签步骤图
        */}

        {isWeixin ? (
          <div className="dl-browser-to">
            <img src="/resources/four-three/browser-to.png" alt="" />
          </div>
        ) : (
          <>
            {!window.navigator.standalone &&
            prod &&
            (mobileDetect.is("iPhone") ||
              mobileDetect.is("iPad") ||
              navigator.userAgent == "app") &&
            window.location.hostname !== "localhost" &&
            !window.location.hostname.startsWith("192.168") &&
            // navs.length === 0 &&
            (location.pathname === "/" || location.pathname === "/game") &&
            !hideBookmarkGuide ? (
              <>
                {/* 抖音推广 在非Safari浏览器*/}
                {(params?.isDou && !douSafari) || !isSafari ? (
                  <div className="swiper-tips-container">
                    <div
                      className="swiper-tips-main swiper-link-tips-main"
                      style={{ position: "relative" }}
                    >
                      <Swiper
                        ref={swiperLinkRef}
                        spaceBetween={10} // 图片之间的间距
                        slidesPerView={1} // 每次展示一个图片
                        loop // 让轮播图循环
                        autoplay={{
                          delay: 2000, // 自动播放的延迟时间（毫秒）
                          disableOnInteraction: true, // 用户交互后不禁用自动播放
                        }}
                        initialSlide={0}
                      >
                        <SwiperSlide>
                          <img src="/resources/gifts/link01.gif" alt="" />
                        </SwiperSlide>
                        <SwiperSlide>
                          <img src="/resources/gifts/link02.gif" alt="" />
                        </SwiperSlide>
                        <SwiperSlide>
                          <img src="/resources/gifts/link03.gif" alt="" />
                        </SwiperSlide>
                      </Swiper>

                      <div className="link-swiper-tips">
                        <div className="link-tips">
                          请使用
                          <img
                            className="link-tips-img"
                            src="/resources/safari.png"
                            alt=""
                          />
                          <span style={{ color: "#2E7BE5" }}>Safari</span>
                          浏览器打开链接
                        </div>
                        <p className="link-tips">安装到桌面即可体验游戏</p>

                        <CopyToClipboard
                          text={copyLink}
                          onCopy={() => Dialog.info("已复制")}
                        >
                          <div className="link-copy">复制链接</div>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {params.mc ? (
                      <div className="mobileconfig-tips">
                        <div className="container">
                          <img src="/resources/mobileconfig.png" alt="" />
                          <a
                            href={URI("//app.9917.cn/webbox.php?")
                              .addQuery("url", window.location.href)
                              .addQuery("name", app.appname)
                              .addQuery("icon", app.appicon)}
                            onClick={() => {
                              setTimeout(() => {
                                window.location.href =
                                  "https://app.9917.cn/cert/embedded.mobileprovision";
                              }, 2500);
                            }}
                          >
                            点击安装
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div className="swiper-tips-container">
                        <div className="swiper-tips-main">
                          <div className="swiper-tips-title">
                            <div className="swiper-tips-img">
                              <Image src={app.appicon} />
                            </div>
                            <div>
                              <p className="swiper-tips-name">
                                添加应用到桌面
                                <span>教程如下↓</span>
                              </p>
                              <p className="swiper-tips-font">
                                添加<span> {app.appname} </span>
                                到手机桌面即可体验游戏啦
                              </p>
                            </div>
                          </div>

                          {/* ios26 版本 */}
                          {ios26 ? (
                            <Swiper
                              ref={swiperRef}
                              spaceBetween={10} // 图片之间的间距
                              slidesPerView={1} // 每次展示一个图片
                              pagination={{ clickable: true }}
                              loop // 让轮播图循环
                              autoplay={{
                                delay: 3500, // 自动播放的延迟时间（毫秒）
                                disableOnInteraction: true, // 用户交互后不禁用自动播放
                              }}
                              initialSlide={0}
                            >
                              <SwiperSlide>
                                <img
                                  src="/resources/gifts/gif01-26.gif"
                                  alt=""
                                />
                              </SwiperSlide>
                              <SwiperSlide>
                                <img
                                  src="/resources/gifts/gif02-26.gif"
                                  alt=""
                                />
                              </SwiperSlide>
                              {app.brand == "seo" ? (
                                <>
                                  <SwiperSlide>
                                    <div style={{ position: "relative" }}>
                                      <img
                                        src="/resources/gifts/tips03-common.gif"
                                        alt=""
                                      />

                                      <div className="tips-third-main">
                                        <div className="tips-third-top">
                                          <div className="icon">
                                            <Image src={app.appicon} alt="" />
                                          </div>
                                          <div className="info">
                                            <div className="name">
                                              {app.appname}
                                            </div>
                                            <div className="url">
                                              {window.location.href}
                                            </div>
                                          </div>
                                        </div>
                                        <p className="tips-font">
                                          一个图标将会添加到你的主屏幕，以便你快速访问此网站
                                        </p>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <div style={{ position: "relative" }}>
                                      <img
                                        src="/resources/gifts/back.png"
                                        alt=""
                                      />

                                      <div
                                        className="desktop-icon"
                                        style={{
                                          animation:
                                            activeIndex === 4
                                              ? "shrink 2s ease-out"
                                              : "none",
                                        }}
                                      >
                                        <div className="desktop-icon-img">
                                          <Image src={app.appicon} alt="" />
                                        </div>

                                        <div className="name">
                                          {app.appname}
                                        </div>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                </>
                              ) : (
                                <SwiperSlide>
                                  <img
                                    src={`/resources/gifts/${
                                      "tips03-" + app.brand || "9917"
                                    }.gif`}
                                    alt=""
                                  />
                                </SwiperSlide>
                              )}
                            </Swiper>
                          ) : (
                            <>
                              {app.brand == "9917" || app.brand == "btwan" ? (
                                <Swiper
                                  ref={swiperRef}
                                  spaceBetween={10} // 图片之间的间距
                                  slidesPerView={1} // 每次展示一个图片
                                  pagination={{ clickable: true }}
                                  loop // 让轮播图循环
                                  autoplay={{
                                    delay: 2500, // 自动播放的延迟时间（毫秒）
                                    disableOnInteraction: true, // 用户交互后不禁用自动播放
                                  }}
                                  initialSlide={0}
                                  onSlideChange={(swiper) => {
                                    const videos =
                                      swiperRef.current.querySelectorAll(
                                        "video",
                                      );

                                    // 暂停所有视频
                                    videos.forEach((video) => {
                                      video.pause();
                                      video.currentTime = 0;
                                    });

                                    // 获取当前活动幻灯片的索引
                                    const activeIndex = swiper.activeIndex;
                                    const activeVideo = videos[activeIndex];

                                    // 如果当前幻灯片有视频，播放它
                                    if (activeVideo) {
                                      activeVideo.play();
                                    }
                                  }}
                                >
                                  <SwiperSlide>
                                    <video
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "20px",
                                      }}
                                      autoPlay
                                      muted
                                      controls={false}
                                      webkit-playsinline="true"
                                      playsInline={true}
                                      src={`/resources/gifts/video01-${app.brand}.mp4`}
                                      type="video/mp4"
                                    ></video>
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <video
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "20px",
                                      }}
                                      autoPlay
                                      muted
                                      controls={false}
                                      webkit-playsinline="true"
                                      playsInline={true}
                                      src={`/resources/gifts/video02-${app.brand}.mp4`}
                                      type="video/mp4"
                                    ></video>
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <video
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "20px",
                                      }}
                                      autoPlay
                                      muted
                                      controls={false}
                                      webkit-playsinline="true"
                                      playsInline={true}
                                      src={`/resources/gifts/video03-${app.brand}.mp4`}
                                      type="video/mp4"
                                    ></video>
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <video
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "20px",
                                      }}
                                      autoPlay
                                      muted
                                      controls={false}
                                      webkit-playsinline="true"
                                      playsInline={true}
                                      src={`/resources/gifts/video04-${app.brand}.mp4`}
                                      type="video/mp4"
                                    ></video>
                                  </SwiperSlide>
                                </Swiper>
                              ) : app.brand == "seo" ? (
                                // 编辑部
                                <Swiper
                                  ref={swiperRef}
                                  spaceBetween={10} // 图片之间的间距
                                  slidesPerView={1} // 每次展示一个图片
                                  pagination={{ clickable: true }}
                                  loop // 让轮播图循环
                                  autoplay={{
                                    delay: 4500, // 自动播放的延迟时间（毫秒）
                                    disableOnInteraction: true, // 用户交互后不禁用自动播放
                                  }}
                                  initialSlide={0}
                                  onSlideChange={(swiper) => {
                                    // 获取当前活动幻灯片的索引
                                    const activeI = swiper.activeIndex;
                                    setActiveIndex(activeI);
                                  }}
                                >
                                  <SwiperSlide>
                                    <img
                                      src="/resources/gifts/tips01.gif"
                                      alt=""
                                    />
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <img
                                      src="/resources/gifts/tips02.gif"
                                      alt=""
                                    />
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <div style={{ position: "relative" }}>
                                      <img
                                        src="/resources/gifts/tips03-common.gif"
                                        alt=""
                                      />

                                      <div className="tips-third-main">
                                        <div className="tips-third-top">
                                          <div className="icon">
                                            <Image src={app.appicon} alt="" />
                                          </div>
                                          <div className="info">
                                            <div className="name">
                                              {app.appname}
                                            </div>
                                            <div className="url">
                                              {window.location.href}
                                            </div>
                                          </div>
                                        </div>
                                        <p className="tips-font">
                                          一个图标将会添加到你的主屏幕，以便你快速访问此网站
                                        </p>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <div style={{ position: "relative" }}>
                                      <img
                                        src="/resources/gifts/back.png"
                                        alt=""
                                      />

                                      <div
                                        className="desktop-icon"
                                        style={{
                                          animation:
                                            activeIndex === 4
                                              ? "shrink 2s ease-out"
                                              : "none",
                                        }}
                                      >
                                        <div className="desktop-icon-img">
                                          <Image src={app.appicon} alt="" />
                                        </div>

                                        <div className="name">
                                          {app.appname}
                                        </div>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                </Swiper>
                              ) : (
                                <Swiper
                                  ref={swiperRef}
                                  spaceBetween={10} // 图片之间的间距
                                  slidesPerView={1} // 每次展示一个图片
                                  pagination={{ clickable: true }}
                                  loop // 让轮播图循环
                                  autoplay={{
                                    delay: 4500, // 自动播放的延迟时间（毫秒）
                                    disableOnInteraction: true, // 用户交互后不禁用自动播放
                                  }}
                                  initialSlide={0}
                                >
                                  <SwiperSlide>
                                    <img
                                      src="/resources/gifts/tips01.gif"
                                      alt=""
                                    />
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <img
                                      src="/resources/gifts/tips02.gif"
                                      alt=""
                                    />
                                  </SwiperSlide>
                                  <SwiperSlide>
                                    <img
                                      src={`/resources/gifts/${
                                        "tips03-" + app.brand || "9917"
                                      }.gif`}
                                      alt=""
                                    />
                                  </SwiperSlide>
                                </Swiper>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            ) : null}
          </>
        )}

        {/* {((prod && (window.navigator.standalone || standalone)) ||
          (!mobileDetect.is("iPhone") &&
            !mobileDetect.is("iPad") &&
            navigator.userAgent != "app") ||
          (params?.isDou && !douSafari) ||
          !prod ||
          window.location.hostname == "localhost" ||
          window.location.hostname.startsWith("192.168")) && ( */}
        <div className={"screen-index " + (navs.length === 0 ? "active" : "")}>
          <div className="screen-body">
            {screenRouter
              .filter((item) => {
                if (!entranceDataList && item.id === "service") {
                  return false;
                }
                return true;
              })
              .map((item) => (
                <div
                  className={
                    "screen-body-item " +
                    item.id +
                    " " +
                    (location.pathname === item.path ? "active" : "")
                  }
                  key={item.id}
                >
                  <ActiveContext.Provider
                    value={navs.length === 0 && location.pathname === item.path}
                  >
                    <item.component
                      active={
                        navs.length === 0 && location.pathname === item.path
                      }
                      action={action}
                    />
                  </ActiveContext.Provider>
                </div>
              ))}
          </div>

          {storageLocal.has("kfUrl") &&
            location.pathname != "/screen-user" &&
            location.pathname != "/screen-trade" && (
              <div
                className="jj-conract-service"
                onClick={() => {
                  window.location.href = `weixin://biz/ww/kefu/${storageLocal.get(
                    "kfUrl",
                  )}?schema=1&refkey=`;
                }}
              >
                <div className="jj-conract-service-icon">
                  <img src="/resources/four-three/vip-icon.png" alt="" />
                  <span>添加客服激活内部首充特权</span>
                </div>

                <p className="btn">去添加</p>
              </div>
            )}

          <div className="screen-menu width" key={location.pathname}>
            <div className="screen-menu-container">
              {screenRouter
                .filter((item) => {
                  if (!entranceDataList && item.id === "service") {
                    return false;
                  }
                  return true;
                })
                .map((item) => {
                  let Tag = item.user ? NavLink : Link;
                  return (
                    <Tag
                      key={item.id}
                      to={item.path}
                      replace
                      className={
                        "screen-menu-item " +
                        (location.pathname === item.path ? "active" : "")
                      }
                    >
                      <div
                        className="icon icon-dark"
                        style={{
                          backgroundImage:
                            "url(/resources/screen/" + item.id + "-dark.png)",
                        }}
                      />
                      <div
                        className="icon icon-highlight"
                        style={{
                          backgroundImage:
                            "url(/resources/screen/" +
                            item.id +
                            "-highlight.png)",
                        }}
                      />
                      <div
                        className="icon icon-white"
                        style={{
                          backgroundImage:
                            "url(/resources/screen/" + item.id + "-white.png)",
                        }}
                      />
                      <div className="text">{item.title}</div>
                    </Tag>
                  );
                })}
            </div>
          </div>
        </div>
        {/* )} */}

        {navs.map((nav, index) => (
          <NavView key={index} {...nav} />
        ))}

        {/* 手机号、账号登录 */}
        <CSSTransition in={showLogin} timeout={250} unmountOnExit={true}>
          <div className="server-region-content">
            <div
              className="server-mask"
              style={{
                zIndex: 9999997,
                opacity: isFromLogin ? 0 : 1,
                visibility: isFromLogin ? "hidden" : "visible",
                transition: "opacity 0.25s ease, visibility 0.25s ease",
              }}
            />
            <div
              className="server-main"
              style={{
                zIndex: 9999998,
                minHeight: "50vh",
                paddingLeft: 0,
                paddingRight: 0,
                opacity: isFromLogin ? 0 : 1,
                visibility: isFromLogin ? "hidden" : "visible",
                transition: "opacity 0.25s ease, visibility 0.25s ease",
              }}
            >
              <div className="login-module-top">
                <div className="login-module-title">
                  <div
                    className={`login-title code-login ${
                      loginType === "code" ? "active" : ""
                    }`}
                    onClick={() => {
                      setLoginType("code");
                    }}
                  >
                    验证码登录
                  </div>
                  <div
                    className={`login-title phone-login ${
                      loginType === "account" ? "active" : ""
                    }`}
                    onClick={() => {
                      setLoginType("account");
                    }}
                  >
                    账号登录
                  </div>
                </div>
                <img
                  className="login-module-close"
                  src="/resources/account/close.png"
                  alt=""
                  onClick={() => {
                    setShowLogin(false);
                    document.body.style.overflow = "";
                  }}
                />
              </div>

              <div className="login-module-content">
                {loginType === "code" ? <PhoneLogin /> : <PasswordLogin />}
              </div>
            </div>
          </div>
        </CSSTransition>

        {/* 注册 */}
        <CSSTransition in={registerShow} timeout={250} unmountOnExit={true}>
          <div className="server-region-content">
            <div
              className="server-main"
              style={{
                zIndex: 9999998,
                minHeight: "50vh",
                paddingLeft: 0,
                paddingRight: 0,
                opacity: isFromLogin ? 0 : 1,
                visibility: isFromLogin ? "hidden" : "visible",
                transition: "opacity 0.25s ease, visibility 0.25s ease",
              }}
            >
              <div
                className="login-module-top"
                style={{ padding: "33px 26px 0", justifyContent: "normal" }}
              >
                <img
                  className="login-module-close"
                  src="/resources/account/back.png"
                  alt=""
                  style={{
                    width: "16px",
                    height: "16px",
                    position: "relative",
                    zIndex: 9,
                  }}
                  onClick={() => {
                    setRegisterShow(false);
                    document.body.style.overflow = "";
                  }}
                />

                <div className="login-module-title register">
                  <div className={`login-title active`}>快速注册</div>
                </div>
              </div>

              <div
                className="login-module-content"
                style={{ paddingTop: "31px" }}
              >
                <Register />
              </div>
            </div>
          </div>
        </CSSTransition>

        {/* 忘记密码 */}
        <CSSTransition in={pswEditShow} timeout={250} unmountOnExit={true}>
          <div className="server-region-content">
            <div
              className="server-main"
              style={{
                zIndex: 9999998,
                minHeight: "50vh",
                paddingLeft: 0,
                paddingRight: 0,
                opacity: isFromLogin ? 0 : 1,
                visibility: isFromLogin ? "hidden" : "visible",
                transition: "opacity 0.25s ease, visibility 0.25s ease",
              }}
            >
              <div
                className="login-module-top"
                style={{ padding: "33px 26px 0", justifyContent: "normal" }}
              >
                <img
                  className="login-module-close"
                  src="/resources/account/back.png"
                  alt=""
                  style={{
                    width: "16px",
                    height: "16px",
                    position: "relative",
                    zIndex: 9,
                  }}
                  onClick={() => {
                    setPswEditShow(false);
                    document.body.style.overflow = "";
                  }}
                />

                <div className="login-module-title register">
                  <div className={`login-title active`}>忘记密码</div>
                </div>
              </div>

              <div
                className="login-module-content"
                style={{ paddingTop: "31px", paddingBottom: "45px" }}
              >
                <PswEdit />
              </div>
            </div>
          </div>
        </CSSTransition>
      </div>

      <div
        id="safeAreaInsetBottom"
        style={{
          height: "env(safe-area-inset-bottom)",
          width: "100%",
          backgroundColor: "transparent",
          display: "none",
        }}
      ></div>
    </>
  );
};
